/* Plasmik3D — Force l'affichage de la cover (1re image) au chargement
   sur les produits Pride Edition, sans toucher au mécanisme de variantes.
   La cover redevient active à l'ouverture ; dès que le client choisit une
   variante, le comportement natif du thème reprend la main. */
(function () {
  function showCover() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    // 1re miniature = la cover (position 1 dans la galerie)
    var firstThumb = gallery.querySelector('[id^="GalleryThumbnails"] [data-target]');
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    // data-media-id de la 1re image du viewer (= cover)
    var firstSlide = viewer.querySelector('[data-media-id]');
    if (!firstSlide) return;
    var coverId = firstSlide.dataset.mediaId;

    // Si la cover est déjà l'image active ET en première position, rien à faire
    var active = viewer.querySelector('.is-active[data-media-id]');
    if (active && active.dataset.mediaId === coverId &&
        viewer.querySelector('[data-media-id]') === active) {
      return;
    }

    // Utilise la méthode native du composant pour activer la cover proprement
    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(coverId, true);
    }
  }

  function run() {
    // produits Pride uniquement : le body porte une classe template ou data
    // on se base sur la présence d'un marqueur injecté dans le Liquid (voir ci-dessous)
    if (!document.querySelector('[data-pride-cover="true"]')) return;
    // léger délai pour laisser le thème finir son init
    window.requestAnimationFrame(function () {
      window.setTimeout(showCover, 60);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
